import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild
} from "@angular/core";
import {FormArray, FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity,
  ClientEntity,
  TrialBalanceItem, Jaarrekening, Jaarrapportage, BokkzJrLogic
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { FeatureTaxReportDetailsComponent } from '../../tax-report-details/feature-tax-report-details.component';
import { combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil } from "rxjs";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SpecTrialbalanceComponent } from '../spec-trialbalance/spec-trialbalance.component';
import { SpecFormattedexplanationComponent } from '../spec-formattedexplanation/spec-formattedexplanation.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-afschrijvingen-iva-mva',
  templateUrl: './spec-afschrijvingen-iva-mva.component.html',
  imports: [
    SharedUiButtonModule,
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    SpecTrialbalanceComponent,
    SpecFormattedexplanationComponent,
    CommonModule
  ],
  styleUrls: ['./spec-afschrijvingen-iva-mva.component.scss']
})
export class SpecAfschrijvingenIvaMvaComponent implements OnInit,OnChanges,OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  private destroy$ = new Subject<void>();
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public isRechtspersoon = false;

  public depreciationPropertyPlantEquipmentAmortisationIntangibleAssetsFg = {} as FormGroup;
  public amortisationIntangibleAssetsFg = {} as FormGroup;
  public depreciationPropertyPlantEquipmentFg = {} as FormGroup;
  public resultSaleIntangibleAssetsFg = {} as FormGroup;
  public resultSalePropertyPlantEquipmentFg = {} as FormGroup;
  public amortisationIntangibleAssetsDisclosureFg = {} as FormGroup;
  public depreciationPropertyPlantEquipmentDisclosureFg = {} as FormGroup;
  public arbitraryDepreciationAmortisationThatExceedsAmountOfRegularDepreciationAmortisationDisclosureFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }
  @ViewChild(FeatureTaxReportDetailsComponent, { static: true }) details!: FeatureTaxReportDetailsComponent;
  constructor(
    public algDataService: BokkzAlgDataService,
    private cdRef: ChangeDetectorRef,
    private jrLogicService: BokkzJrLogic,
    public jrDataService: BokkzJrDataService,
    ) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }

    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });

    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {
    this.depreciationPropertyPlantEquipmentAmortisationIntangibleAssetsFg = this.jrDataService.createFormGroupMonetaryNoDecimalsPeriodValues()
    this.amortisationIntangibleAssetsFg = this.jrDataService.createFormGroupBalanceItem();
    this.depreciationPropertyPlantEquipmentFg = this.jrDataService.createFormGroupBalanceItem();
    this.resultSaleIntangibleAssetsFg = this.jrDataService.createFormGroupBalanceItem();
    this.resultSalePropertyPlantEquipmentFg = this.jrDataService.createFormGroupBalanceItem();
    this.amortisationIntangibleAssetsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.depreciationPropertyPlantEquipmentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.arbitraryDepreciationAmortisationThatExceedsAmountOfRegularDepreciationAmortisationDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
  }

  private patchData(value: JaarrapportageEntity) {

    const afschrijvingenIvaMva = value.rapportage?.jaarrekeningen?.at(0)?.winstEnVerliesrekening?.afschrijvingenIvaMva;

    if (afschrijvingenIvaMva) {
      this.depreciationPropertyPlantEquipmentAmortisationIntangibleAssetsFg.reset();

      if (afschrijvingenIvaMva.depreciationPropertyPlantEquipmentAmortisationIntangibleAssets) {
        this.depreciationPropertyPlantEquipmentAmortisationIntangibleAssetsFg.patchValue(afschrijvingenIvaMva.depreciationPropertyPlantEquipmentAmortisationIntangibleAssets, {emitEvent: false})
      }

      const uitsplitsing = afschrijvingenIvaMva.afschrijvingenIvaMvaUitsplitsing;
      const tekstueel = afschrijvingenIvaMva.afschrijvingenIvaMvaTekstueel;
      if (uitsplitsing) {
        if (uitsplitsing.amortisationIntangibleAssets) {
          const subItem = uitsplitsing.amortisationIntangibleAssets;
          this.amortisationIntangibleAssetsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems, this.amortisationIntangibleAssetsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.depreciationPropertyPlantEquipment) {
          const subItem = uitsplitsing.depreciationPropertyPlantEquipment;
          this.depreciationPropertyPlantEquipmentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.depreciationPropertyPlantEquipmentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.resultSaleIntangibleAssets) {
          const subItem = uitsplitsing.resultSaleIntangibleAssets;
          this.resultSaleIntangibleAssetsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.resultSaleIntangibleAssetsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.resultSalePropertyPlantEquipment) {
          const subItem = uitsplitsing.resultSalePropertyPlantEquipment;
          this.resultSalePropertyPlantEquipmentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.resultSalePropertyPlantEquipmentFg.get('trialBalanceItems') as FormArray)
        }
      }
      if (tekstueel) {
        if (tekstueel.amortisationIntangibleAssetsDisclosure) {
          this.amortisationIntangibleAssetsDisclosureFg.patchValue(tekstueel.amortisationIntangibleAssetsDisclosure);
        }
        if (tekstueel.depreciationPropertyPlantEquipmentDisclosure) {
          this.depreciationPropertyPlantEquipmentDisclosureFg.patchValue(tekstueel.depreciationPropertyPlantEquipmentDisclosure);
        }
        if (tekstueel.arbitraryDepreciationAmortisationThatExceedsAmountOfRegularDepreciationAmortisationDisclosure) {
          this.arbitraryDepreciationAmortisationThatExceedsAmountOfRegularDepreciationAmortisationDisclosureFg.patchValue(tekstueel.arbitraryDepreciationAmortisationThatExceedsAmountOfRegularDepreciationAmortisationDisclosure);
        }
      }
    }
  }

  updateTrialBalanceItems(lijst?: TrialBalanceItem[], formArray?: FormArray) {
    if (lijst && formArray) {
      for (let i = 0; i < lijst.length; i++) {
        if (i < formArray.length) {
          const control = formArray.at(i) as FormGroup;
          control.patchValue(lijst[i]);
        } else {
          const formGroup = this.jrDataService.createFormGroupTrialBalanceItem(lijst[i])
          formArray.push(formGroup);
        }
      }
    }
  }

  public saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });
    this.depreciationPropertyPlantEquipmentAmortisationIntangibleAssetsFg.updateValueAndValidity();
    this.amortisationIntangibleAssetsFg.updateValueAndValidity();
    this.depreciationPropertyPlantEquipmentFg.updateValueAndValidity();
    this.resultSaleIntangibleAssetsFg.updateValueAndValidity();
    this.resultSalePropertyPlantEquipmentFg.updateValueAndValidity();
    this.amortisationIntangibleAssetsDisclosureFg.updateValueAndValidity();
    this.depreciationPropertyPlantEquipmentDisclosureFg.updateValueAndValidity();
    this.arbitraryDepreciationAmortisationThatExceedsAmountOfRegularDepreciationAmortisationDisclosureFg.updateValueAndValidity();

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        winstEnVerliesrekening: {
          ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening,
          afschrijvingenIvaMva: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.afschrijvingenIvaMva,
            afschrijvingenIvaMvaUitsplitsing: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.afschrijvingenIvaMva?.afschrijvingenIvaMvaUitsplitsing,
              amortisationIntangibleAssets: this.amortisationIntangibleAssetsFg.value,
              depreciationPropertyPlantEquipment: this.depreciationPropertyPlantEquipmentFg.value,
              resultSaleIntangibleAssets: this.resultSaleIntangibleAssetsFg.value,
              resultSalePropertyPlantEquipment: this.resultSalePropertyPlantEquipmentFg.value,
            },
            afschrijvingenIvaMvaTekstueel: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.afschrijvingenIvaMva?.afschrijvingenIvaMvaTekstueel,
              amortisationIntangibleAssetsDisclosure: this.amortisationIntangibleAssetsDisclosureFg.value,
              depreciationPropertyPlantEquipmentDisclosure: this.depreciationPropertyPlantEquipmentDisclosureFg.value,
              arbitraryDepreciationAmortisationThatExceedsAmountOfRegularDepreciationAmortisationDisclosure: this.arbitraryDepreciationAmortisationThatExceedsAmountOfRegularDepreciationAmortisationDisclosureFg.value,
            }
          },
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
    this.jrLogicService.getCalculation(this.jrEntity)
  }
}

